import { getLoginPath } from '@/bundle/Auth/LoginFlow/LoginPage/path/path';
import { AuthLayout } from '@/bundle/Auth/ui/AuthLayout/AuthLayout';
import { AuthStep } from '@/bundle/Auth/ui/AuthStep/AuthStep';
import { Box } from '@/components/Box/Box';
import { useNavigate } from 'react-router';
import ExpiredLinkIcon from '@/images/ExpiredLinkIcon.svg?react';
import { AuthTitle } from '../../ui/AuthTitle/AuthTitle';
import { Button } from '@/components/Button/Button';
import { AuthMessage } from '../../ui/styles';

export const EmailConfirmationExpiredPage = () => {
  const navigate = useNavigate();

  const redirectToLogin = () => {
    return navigate(getLoginPath());
  };

  return (
    <AuthLayout>
      <AuthStep>
        <Box alignItems='center' flexDirection='column'>
          <Box marginBottom='28px'>
            <ExpiredLinkIcon />
          </Box>
          <AuthTitle marginBottom={16}>The link has been expired</AuthTitle>
          <Box marginBottom='32px'>
            <AuthMessage>Please log in or contact the Admin of the inviting organization.</AuthMessage>
          </Box>
          <Button onClick={redirectToLogin}>Return to Login</Button>
        </Box>
      </AuthStep>
    </AuthLayout>
  );
};
